import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "access-security-gates-sydney";
const serviceId = 5;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Automatic Security Gates Sydney | Ozy Wide Group",
    description:
      "Automated gate and controlled-entry support for driveways, perimeter points and commercial access areas.",
    keywords:
      "automatic security gates Sydney, gate automation, electric gates, perimeter security, gate access control, driveway gates",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Automatic Security Gates",
    description:
      "Automated gate and controlled-entry support for driveways, perimeter points and commercial access areas.",
    points: createServicePoints(
      "Gate access and safety reviewed",
      "Controls, remotes and keypads planned",
      "Perimeter entry tested for daily use",
    ),
    images: createImageItems(images, "Automatic Security Gates Sydney"),
    content,
  };
